import React, { useEffect, useState } from 'react'
import MaterialTable from 'material-table';
import { useSelector } from 'react-redux';
import { darken, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

import { dataAxureFetch } from '../../../helpers/fetch';
import { COLORS_PROJECT,REALTIME_INTERVAL_SECONDS } from '../../../constants';
import './css/alarmsTable.css'

const { color_nav, color_nav_letter} = COLORS_PROJECT;

export const GisInformationAlarmsTable = ({filters,getDataToggle,realtime}) => {

    const {uid,colorPoints,ptws} = useSelector((state) => state.auth);
    const {nameAlerts} = useSelector(state => state.auth) //nameColors
    const [data, setData] = useState([]);

    useEffect(() => {
        if (!realtime) {
            return;
        }
        getPointsRealtime();
        let unmounted = false;
        const interval = setInterval(() => {
            if (!unmounted) {
                getPointsRealtime();
            }
        }, REALTIME_INTERVAL_SECONDS * 1000);
        return () => {
            if (!realtime) {
                return;
            }
            unmounted = true;
            clearInterval(interval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (getDataToggle) {
            getPointsHistoric();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getDataToggle]);

  
    const getPointsRealtime = async () => {
        try {
            const responseTotalPointsActives = await dataAxureFetch({ solicitud: "NomPuntosAlert", idCliente: uid, ptws:ptws }, 'POST');
            if (responseTotalPointsActives !== null) {
                responseTotalPointsActives.pop()
                setData(responseTotalPointsActives)
            } else {
                setData([])
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getPointsHistoric = async()  =>{
        const responseTotalPointsActives = await dataAxureFetch(
            {
                nomHRT: filters.pointName,
                idCliente: uid,
                fecIHRT: filters.startDate,
                fecFHRT: filters.endDate,
            },
            'POST'
        );
        const {0:response} = responseTotalPointsActives ;  

        if(response){
            setData(response.puntos_alertados)
        }else{
            setData([])
        }

    }

    const columnsRealTime =[
        { field: 'nombre', title: 'TWS' },
        { field: 'fecha_on', title: 'Fecha Encendido' },
        { field: 'tiempo_apagado', title: 'Tiempo de apagado'},
        //{ field: 'nivel', title: 'Nivel de alerta' },
        {
            field: 'nivel', 
            title: 'Alerta',
            render: rowData => {
                switch (rowData.nivel) {
                    case 1:
                        return `${arrNamesAlerts[0]}`
                    case 2: 
                        return `${arrNamesAlerts[1]}`
                    case 3: 
                        return `${arrNamesAlerts[2]}`
                    default:
                        return '';
                }
            }
        },
    ]

    const columnsHistoric =[
        { field: 'nombre', title: 'TWS' },
        { field: 'fecha_on', title: 'Fecha Encendido' },
        //{ field: 'nivel', title: 'Nivel Alerta' },
        {
            field: 'nivel', 
            title: 'Alerta',
            render: rowData => {
                switch (rowData.nivel) {
                    case 1:
                        return `${arrNamesAlerts[0]}`
                    case 2: 
                        return `${arrNamesAlerts[1]}`
                    case 3: 
                        return `${arrNamesAlerts[2]}`
                    default:
                        return '';
                }
            }
        },
    ]

    let columnsField;

    if(realtime){
        columnsField= columnsRealTime
    }else{
        columnsField= columnsHistoric
    }


    if(data.length === 0){
        return (
            <Typography component="h3" variant="h6" color="textPrimary" align="center" style={{padding:70}}>
                No hay alertas activas
            </Typography>
        )
    }
    
    const arrColors = colorPoints.split(",")
    const arrNamesAlerts = nameAlerts.split(",")
    
    return (
        <>
            
            <MaterialTable
              columns={columnsField}
           /*    columns = {[
                {field: 'nombre', title: 'TWS'},
                {field: 'fecha_on', title: 'Fecha Encendido'},
                {field: 'tiempo_apagado', title: 'Tiempo Apagado'},
                {
                    field: 'nivel', 
                    title: 'Nivel Alerta',
                    render: rowData => {
                        switch (rowData.nivel) {
                            case 1:
                                return `${arrNamesAlerts[0]}`
                            case 2: 
                                return `${arrNamesAlerts[1]}`
                            case 3: 
                                return `${arrNamesAlerts[2]}`
                            default:
                                return '';
                        }
                    }
                },

            ]} */
                data={data}
                options={
                    {
                        padding: 'dense',
                        showTitle: false,
                        search: false,
                        toolbar: false,
                        headerStyle: {
                            backgroundColor: darken(color_nav, 0.2),
                            color: color_nav_letter,
                            paddingRight: 0,
                            textAlign: "center",
                            justifyContent: "center",
                            paddingBottom: 0,
                            height:70,  
                        },
                        tableLayout: 'auto',
                        rowStyle: rowData=>{
                            switch (rowData.nivel) {
                                case 3:
                                    return {backgroundColor: arrColors[3]};
                                case 2:
                                    return {backgroundColor: arrColors[2]};
                                case 1:
                                    return {backgroundColor: arrColors[1],};    
                                default:
                                    return {};
                            }
                        },
                        pageSizeOptions: [10, 20],
                        pageSize: 50,
                        maxBodyHeight: 200,
                    }
                }

                localization={{
                    pagination:{
                        labelRowsSelect: 'filas',
                        firstAriaLabel: 'Primera página',
                        firstTooltip: 'Primera página',
                        previousAriaLabel: 'Página anterior',
                        previousTooltip: 'Página anterior',
                        nextAriaLabel: 'Página siguiente',
                        nextTooltip: 'Página siguiente',
                        lastAriaLabel: 'Ultima página',
                        lastTooltip: 'Ultima página',
                    },
                    body:{
                        emptyDataSourceMessage: 'No hay Alertas activas',
                    }
                }}
                style={{
                    height: 210,
                    overflowY: 'hidden',
                    overflowX:'hidden'
                }}

                title="TWS"
            />
        </>
    )
}

GisInformationAlarmsTable.propTypes={
    filters: PropTypes.object,
    getDataToggle: PropTypes.bool,
    realtime: PropTypes.bool,
}